$(window).on('load scroll resize', function() {
	if ($(window).width() >= 768) {
		// if not homepage
		const header = $('.header').outerHeight();
		checkTop(header, 'show-sticky', '.header--sticky');
	}
});

function checkTop(number, cls, element) {
	const top = $(window).scrollTop();

	if (top > number) {
		$(element).addClass(cls);
	} else {
		$(element).removeClass(cls);
	}
}
